import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Required-field validator that also rejects whitespace-only input.
 *
 * Angular's Validators.required accepts "   " because the string is not
 * empty. This validator reports the same `required` error for it, so the
 * form shows the "required" message instead of accepting a blank value.
 *
 * Usage:
 * ```typescript
 * label: ['', [notBlankValidator(), Validators.maxLength(100)]]
 * ```
 */
export function notBlankValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: unknown = control.value;
    const isBlank = typeof value !== 'string' || value.trim().length === 0;
    return isBlank ? { required: true } : null;
  };
}
